let originalHandleAddGift;

const removeAllRemainingGifts = async (currentlyAppliedRuleIds) => {
    const unappliedRuleIds = window.tlAdvancedFreeGift.rules
        .map(({ id }) => {
            if (!currentlyAppliedRuleIds.includes(id) && window.tlAdvancedFreeGift.ruleIdMapGiftAddedByApp.get(id)) {
                return {
                    id,
                    claimed: 0,
                    can_claim: 0,
                };
            }
        })
        .filter(Boolean);

    if (!unappliedRuleIds.length) return;

    await window.tlAdvancedFreeGift.handleRemoveGift(unappliedRuleIds);

    window.tlAdvancedFreeGift.ruleIdMapGiftQtyInCart = new Map();
    window.tlAdvancedFreeGift.ruleIdMapGiftAddedByApp = new Map();
};

function getRuleIdWithMaxConditionValue(applicableIds) {
    let maxId = null;
    let maxValue = -Infinity;

    for (const id of applicableIds) {
        const data = window.tlAdvancedFreeGift.ruleIdMapData.get(id);
        if (data && data.apply_condition_value > maxValue) {
            maxValue = data.apply_condition_value;
            maxId = id;
        }
    }

    return maxId;
}

const newHandleAddGift = async (listRuleId) => {
    await removeAllRemainingGifts(listRuleId);

    const ruleIdWithMaxConditionValue = getRuleIdWithMaxConditionValue(listRuleId);
    await originalHandleAddGift([ruleIdWithMaxConditionValue]);
};

const intervalId = setInterval(() => {
    if (window.tlAdvancedFreeGift) {
        clearInterval(intervalId);

        originalHandleAddGift = window.tlAdvancedFreeGift.handleAddGift;
        window.tlAdvancedFreeGift.handleAddGift = newHandleAddGift;
    }
}, 50);

setTimeout(() => clearInterval(intervalId), 5000);
